import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import _get from 'lodash/get';
import { bindActionCreators } from 'redux';
import ScriptLoader from 'yoda-core-components/lib/helpers/ScriptLoader/ScriptLoader';
import { SessionStorage } from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';
import * as actions from '../../actions/ProductCartridgeAction';
import SiteComponent from '../SiteComponent/SiteComponent';
import { BRANCH_IO_BRANCHIO_LIVE_KEY } from '../../common/Constants';
import analyticsAction from '../../actions/AnalyticsAction';

export class AppBanner extends SiteComponent {
    constructor() {
        super();
        this.branchIoLoaded = this.branchIoLoaded.bind(this);
        this.didShowJourneyListener = this.didShowJourneyListener.bind(this);
        this.didCloseJourneyListener = this.didCloseJourneyListener.bind(this);
    }

    static defaultProps = {
        enable: true,
        deviceType: {},
        enableAppBannerAnalytics: false,
        staticHosts: '',
        cluster: '',
    };

    static propTypes = {
        enable: PropTypes.bool,
        deviceType: PropTypes.object,
        enableAppBannerAnalytics: PropTypes.bool,
        staticHosts: PropTypes.string,
        cluster: PropTypes.string,
    };

    componentDidMount() {
        /* istanbul ignore next */
        if (
            !__SERVER__ &&
            (this.props.deviceType.isMobile || this.props.deviceType.isTablet) &&
            this.props.enable
        ) {
            this.loadAppBanner();
        }
    }

    loadAppBanner() {
        const { staticHosts, cluster } = this.props;
        const resonanceUrl = `//${staticHosts}/${cluster}/yoda-assets/vendor/branch.io.js`;
        const branchIoProps = {
            src: resonanceUrl,
            onSuccess: this.branchIoLoaded,
        };
        ScriptLoader.load(branchIoProps);
    }

    didShowJourneyListener(delayForBranchioEvent) {
        setTimeout(() => {
            this.props.actions.triggerAppBannerOpen();
            SessionStorage.setData('AppBannerImpresion', true, true);
        }, delayForBranchioEvent);
    }

    didCloseJourneyListener() {
        this.props.actions.triggerAppBannerClose();
    }

    branchIoLoaded() {
        const { delayForBranchioEvent } = this.props;
        if (!__SERVER__ && window.branch) {
            const deeplinkPath =
                window.location.pathname + window.location.search + window.location.hash;
            window.branch.init(this.props.branchIOKey);
            const keyValue = SessionStorage.getData('AppBannerImpresion', true);
            /* istanbul ignore next */
            if (this.props.enableAnalyticsAppBanner) {
                if (!keyValue) {
                    window.branch.addListener('didShowJourney', () => {
                        this.didShowJourneyListener(delayForBranchioEvent);
                    });
                }
                window.branch.addListener('didCloseJourney', this.didCloseJourneyListener);
            }
            window.branch.setBranchViewData({
                tags: 'Yoda Mobile Web',
                open_app: true,
                data: {
                    $deeplink_path: deeplinkPath,
                },
            });
            if (window.branch.track) {
                window.branch.track('pageview');
            }
        }
    }

    renderAppBanner() {
        if (
            (this.props.deviceType.isMobile || this.props.deviceType.isTablet) &&
            this.props.enable
        ) {
            return <div className="branch-journeys-top" />;
        }
        return null;
    }

    render() {
        return this.renderAppBanner();
    }
}
/* istanbul ignore next */
const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({ ...analyticsAction, ...actions }, dispatch),
});
/* istanbul ignore next */
const mapStateToProps = ({ context }) => ({
    deviceType: context ? context.deviceType : {},
    enableAnalyticsAppBanner:
        context && context.featureFlags ? context.featureFlags.enableAppBannerAnalytics : null,
    delayForBranchioEvent:
        context && context.preferences && context.preferences.appbanner
            ? context.preferences.appbanner.branchioEventDelayTime
            : null,
    branchIOKey: _get(context, 'preferences.branchIOKey', BRANCH_IO_BRANCHIO_LIVE_KEY),
    staticHosts: context && context.staticHosts && context.staticHosts.app,
    cluster: context && context.cluster,
});

export default connect(mapStateToProps, mapDispatchToProps)(AppBanner);
